// Hệ thống phân quyền RBAC - Role & Permission Templates
// Dựa trên các permissions thực tế của hệ thống GSWM

export const PERMISSION_GROUPS = {
  DASHBOARD: {
    name: 'Bảng điều khiển',
    permissions: [
      {
        id: 1,
        name: 'dashboard_view',
        description: 'Truy cập bảng điều khiển chính, tìm kiếm/ lọc dữ liệu.'
      },
      { id: 2, name: 'dashboard_export', description: 'Xuất Excel dữ liệu từ bảng điều khiển.' }
    ]
  },
  MAP: {
    name: 'Bản đồ',
    permissions: [
      {
        id: 3,
        name: 'map_view',
        description: 'Xem bản đồ thiết bị/vị trí và tìm kiếm/ lọc dữ liệu.'
      }
    ]
  },
  DEVICE: {
    name: 'Quản lý thiết bị',
    permissions: [
      {
        id: 4,
        name: 'device_view',
        description: 'Xem danh sách, tìm kiếm/lọc dữ liệu, và xem chi tiết thiết bị.'
      },
      { id: 5, name: 'device_modify', description: 'Thêm, sửa, hoặc xóa thông tin thiết bị.' },
      { id: 6, name: 'device_export', description: 'Xuất dữ liệu thiết bị ra file Excel.' },
      { id: 7, name: 'device_import', description: 'Nhập dữ liệu thiết bị từ file Excel.' }
    ]
  },
  COMMAND: {
    name: 'Quản lý lệnh',
    permissions: [
      {
        id: 8,
        name: 'command_history_view',
        description: 'Xem dữ liệu lịch sử truyền lệnh (không bao gồm lệnh trả về).'
      },
      {
        id: 9,
        name: 'command_set_basic',
        description: 'Đặt các lệnh cơ bản (ví dụ: Đặt chỉ số ĐH).'
      },
      {
        id: 10,
        name: 'command_set_advanced',
        description: 'Đặt các lệnh nâng cao (chu kỳ, valve, server...).'
      },
      { id: 11, name: 'command_view_response', description: 'Xem lệnh trả về chi tiết.' },
      {
        id: 12,
        name: 'command_export_full',
        description: 'Xuất lịch sử truyền lệnh có bao gồm cột "Lệnh trả về".'
      },
      {
        id: 13,
        name: 'command_view_meter_reading_history',
        description: 'Xem lệnh cài đặt chỉ số gần đây.'
      },
      {
        id: 14,
        name: 'command_set_meter_reading',
        description: 'Chọn thiết bị, nhập chỉ số, gửi lệnh.'
      }
    ]
  },
  REPLACEMENT: {
    name: 'Quản lý thay thế',
    permissions: [
      {
        id: 15,
        name: 'replacement_view',
        description:
          'Xem danh sách, tìm kiếm/lọc dữ liệu, và xem chi tiết sự kiện thay thế lắp mới.'
      },
      {
        id: 16,
        name: 'replacement_modify',
        description: 'Thêm, sửa, hoặc xóa sự kiện thay thế lắp mới.'
      },
      {
        id: 17,
        name: 'replacement_export',
        description: 'Xuất dữ liệu sự kiện thay thế lắp mới ra file Excel.'
      },
      {
        id: 18,
        name: 'replacement_import',
        description: 'Nhập dữ liệu sự kiện thay thế lắp mới từ file Excel.'
      }
    ]
  },
  ORIGINAL_DATA: {
    name: 'Dữ liệu gốc',
    permissions: [
      { id: 19, name: 'original_data_view', description: 'Xem, tìm kiếm/ lọc dữ liệu gốc.' },
      { id: 20, name: 'original_data_export', description: 'Xuất báo cáo dữ liệu gốc.' }
    ]
  },
  CONSUMPTION: {
    name: 'Thống kê tiêu thụ',
    permissions: [
      {
        id: 21,
        name: 'consumption_view',
        description: 'Xem, tìm kiếm/ lọc dữ liệu thống kê tiêu thụ theo ngày/tháng.'
      },
      {
        id: 22,
        name: 'consumption_calculate',
        description: 'Tính toán lại dữ liệu tiêu thụ, xem các yêu cầu tính.'
      },
      {
        id: 23,
        name: 'consumption_manual_import',
        description: 'Import chỉ số thủ công và vào chỉ số thủ công.'
      },
      { id: 24, name: 'consumption_export', description: 'Xuất báo cáo thống kê tiêu thụ.' }
    ]
  },
  WARNING: {
    name: 'Quản lý cảnh báo',
    permissions: [
      {
        id: 25,
        name: 'warning_view',
        description: 'Xem, tìm kiếm/ lọc dữ liệu thống kê cảnh báo.'
      },
      {
        id: 26,
        name: 'warning_update_status',
        description: 'Cập nhật lại trạng thái xử lý cảnh báo.'
      },
      { id: 27, name: 'warning_export', description: 'Xuất Excel dữ liệu thống kê cảnh báo.' }
    ]
  },
  CUSTOMER: {
    name: 'Quản lý khách hàng',
    permissions: [
      {
        id: 28,
        name: 'customer_view',
        description: 'Xem danh sách, tìm kiếm/lọc dữ liệu, và xem chi tiết khách hàng.'
      },
      { id: 29, name: 'customer_modify', description: 'Thêm, sửa, hoặc xóa khách hàng.' },
      { id: 30, name: 'customer_export', description: 'Xuất dữ liệu khách hàng ra file Excel.' },
      { id: 31, name: 'customer_import', description: 'Nhập dữ liệu khách hàng từ file Excel.' }
    ]
  },
  USER_MANAGEMENT: {
    name: 'Quản lý người dùng',
    permissions: [
      { id: 32, name: 'user_view', description: 'Xem, tìm kiếm/ lọc dữ liệu người dùng.' },
      { id: 33, name: 'user_modify', description: 'Thêm/ xoá người dùng.' },
      {
        id: 34,
        name: 'auth_manage',
        description: 'Xem, sửa quyền người dùng (Phân quyền người dùng).'
      }
    ]
  }
};

export const ROLE_TEMPLATES = [
  {
    name: 'SUPER_ADMIN',
    display_name: 'Quản trị viên tối cao',
    description: 'Có toàn quyền truy cập hệ thống',
    permissions: Object.values(PERMISSION_GROUPS).flatMap((group) =>
      group.permissions.map((p) => p.id)
    )
  },
  {
    name: 'ADMIN',
    display_name: 'Quản trị viên',
    description: 'Quản lý dữ liệu và người dùng, không bao gồm quyền phân quyền',
    permissions: [
      // Dashboard & Map
      1, 2, 3,
      // Device management
      4, 5, 6, 7,
      // Command basic & history
      8, 9, 11, 13, 14,
      // Replacement management
      15, 16, 17, 18,
      // Data viewing & export
      19, 20, 21, 24,
      // Warning management
      25, 26, 27,
      // Customer management
      28, 29, 30, 31,
      // User viewing only
      32
    ]
  },
  {
    name: 'MANAGER',
    display_name: 'Người quản lý',
    description: 'Xem và xuất báo cáo, quản lý cảnh báo và một số thao tác cơ bản',
    permissions: [
      // Dashboard & Map
      1, 2, 3,
      // Device viewing & export
      4, 6,
      // Command basic only
      8, 9, 13, 14,
      // Replacement viewing & export
      15, 17,
      // Data viewing & export
      19, 20, 21, 24,
      // Warning management
      25, 26, 27,
      // Customer viewing & export
      28, 30
    ]
  },
  {
    name: 'OPERATOR',
    display_name: 'Vận hành viên',
    description: 'Thực hiện các tác vụ vận hành cơ bản như đặt lệnh và xem dữ liệu',
    permissions: [
      // Dashboard & Map
      1, 3,
      // Device viewing
      4,
      // Command operations
      8, 9, 11, 13, 14,
      // Basic data viewing
      19, 21,
      // Warning viewing
      25,
      // Customer viewing
      28
    ]
  },
  {
    name: 'TECHNICIAN',
    display_name: 'Kỹ thuật viên',
    description: 'Quản lý thiết bị, thay thế và các lệnh nâng cao',
    permissions: [
      // Dashboard & Map
      1, 2, 3,
      // Full device management
      4, 5, 6, 7,
      // Advanced commands
      8, 9, 10, 11, 12, 13, 14,
      // Replacement management
      15, 16, 17, 18,
      // Data viewing & export
      19, 20, 21, 24,
      // Warning viewing
      25, 27
    ]
  },
  {
    name: 'ANALYST',
    display_name: 'Chuyên viên phân tích',
    description: 'Xem, phân tích và xuất các loại báo cáo dữ liệu',
    permissions: [
      // Dashboard with export
      1, 2,
      // Device viewing & export
      4, 6,
      // Command history viewing
      8, 11, 13,
      // Data analysis
      19, 20, 21, 22, 24,
      // Warning analysis
      25, 27,
      // Customer data
      28, 30
    ]
  },
  {
    name: 'VIEWER',
    display_name: 'Người xem',
    description: 'Chỉ xem dữ liệu cơ bản, không có quyền thay đổi',
    permissions: [
      // Basic viewing only
      1, 3, 4, 8, 19, 21, 25, 28
    ]
  }
];

export const PERMISSION_DESCRIPTIONS = {
  // Dashboard
  dashboard_view: 'Xem bảng điều khiển chính',
  dashboard_export: 'Xuất dữ liệu dashboard',

  // Map
  map_view: 'Xem bản đồ thiết bị',

  // Device
  device_view: 'Xem danh sách thiết bị',
  device_modify: 'Thêm/sửa/xóa thiết bị',
  device_export: 'Xuất dữ liệu thiết bị',
  device_import: 'Nhập dữ liệu thiết bị',

  // Command
  command_history_view: 'Xem lịch sử lệnh',
  command_set_basic: 'Đặt lệnh cơ bản',
  command_set_advanced: 'Đặt lệnh nâng cao',
  command_view_response: 'Xem phản hồi lệnh',
  command_export_full: 'Xuất lịch sử lệnh đầy đủ'

  // And so on for other categories...
};
